module.exports = __webpack_public_path__ + "img/PL00147.5a27226c.png";